import { useTheme } from '../../theme/ThemeContext';
export const useTextBlockStyles = ({
  size,
  weight,
  color,
  align
}) => {
  const theme = useTheme();
  const COLOR_MAP = {
    default: theme.colors.text,
    secondary: theme.colors.textSecondary,
    accent: theme.colors.primary,
    muted: theme.colors.textMuted,
    danger: theme.colors.danger
  };
  const SIZE_MAP = {
    sm: theme.fontSizes.sm,
    md: theme.fontSizes.md,
    lg: theme.fontSizes.lg,
    xl: theme.fontSizes.xl
  };
  return Object.assign({
    fontSize: size ? SIZE_MAP[size] : theme.fontSizes.lg,
    fontWeight: weight === 'bold' ? theme.fontWeights.bold : theme.fontWeights.normal,
    color: color ? COLOR_MAP[color] : theme.colors.text
  }, align && {
    textAlign: align
  }, {
    margin: 0
  });
};